import { debounce } from 'lodash-es';

export default function (propertyName, debounceAmount = 0, debounceConfig = {}) {
  return {
    data: () => ({
      onWindowScrollDebounced: null,
      [propertyName]: {
        x: 0,
        y: 0,
      },
    }),
    created() {
      if (this.$isServer) return;

      this.onWindowScrollListener = () => {
        // window.pageX/YOffset is equivalent to window.scrollX/Y, but works in IE
        // We round values because high-DPI devices can provide some really nasty subpixel values
        this[propertyName].x = Math.round(window.pageXOffset);
        this[propertyName].y = Math.round(window.pageYOffset);
      };

      // Call listener once to detect initial position
      this.onWindowScrollListener();

      // When scrolling, update the position
      this.onWindowScrollDebounced = debounce(this.onWindowScrollListener, debounceAmount, debounceConfig);

      window.addEventListener('scroll', this.onWindowScrollDebounced);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.onWindowScrollDebounced);
    },
  };
}
